/* eslint-disable max-len */

const CAR_STORAGE_DATA = [
	{
		heading: "Car Storage",
		level: "2",
		description:
			"Cars are often among the most valuable items you own, so you should take storing one seriously. Many car owners go on extended vacations and need a place to store their car, or they just have a spare car that’s taking up space. Leaving these cars in a driveway or garage can get very annoying. Instead, you can store your vehicle at a nearby storage facility to protect it and have more space at home."
	},
	{
		heading: "Convenience of car storage",
		level: "3",
		description:
			"If you have a spare car that rarely gets driven, you know how frustrating it can be to have it taking up space in your driveway or garage. Instead of maneuvering around it every day, you can move it to self storage and gain back that driveway space.",
		description2:
			"For those needing a safe place to leave a vehicle while they’re away, vehicle storage can be a great solution. Auto storage helps you avoid parking your car out on the street or in long-term parking."
	},
	{
		heading: "Reasons for using auto storage",
		level: "3",
		description:
			"There are many reasons why people turn to vehicle storage, but they almost always come down to space. When a vehicle isn’t used often, it turns into an obstacle in your driveway or garage.",
		description2:
			"Here are a few reasons why people turn to vehicle storage:",

		points: [
			{
				title: "Outdoor Storage: ",
				desc: "Outdoor storage is the most affordable solution and comes with the protection of high fences and gated access but has no protection from the elements."
			},
			{
				title: "Indoor Storage: ",
				desc: "Some storage facilities have large garages where several cars can be parked. While this isn’t a private area, your car will be protected from potential thieves and the elements. Some will even offer trickle charging to keep your car battery fresh."
			},
			{
				title: "Drive-Up Storage: ",
				desc: "Another option for storing your vehicle is to rent a drive-up storage unit. This is similar to storing your car in a single-car garage. It’s completely private and protects your vehicle from damages and theft"
			}
		],
		description3:
			"Choosing between these storage options usually comes down to what your budget is and what kind of car you plan to store. If it’s a classic car, you probably wouldn’t want it to be outside where sun and rain can damage the paint. If you’re simply storing a regular car and want to save some money, then outdoor storage will be the most affordable solution."
	},
	{
		heading: "Car Storage FAQs",
		level: "3",
		subHeadings: [
			{
				title: "What is trickle charging, and is it necessary?",
				desc: "A trickle charger is a charger for car batteries that can be left on the battery for long periods of time. A trickle charger keeps your battery from losing all charge as well as from becoming overcharged. Trickle chargers run between $15-$100, depending on how many amps you need. The longer your car is in storage, the more amps the battery will need.",
				desc2: "It may be safest to remove the battery and place it on a trickle charger in your own home, rather than leaving it in the storage unit."
			},
			{
				title: "Is it bad for my car to sit unused for long periods of time?",
				descLink: {
					contentBefore:
						"It depends. While it’s not ideal for a car so sit unused for long periods of time, there are ",
					linkText:
						"steps you can take to prepare it for long-term storage ",
					link: "https://www.storage.com/blog/the-complete-guide-to-vehicle-storage/",
					contentAfter:
						"For instance, fill up the gas tank and get the oil changed."
				}
			},
			{
				title: "Do I need a special kind of insurance coverage?",
				desc: "Though you may not be driving your car for a while, it must remain registered and insured to be in a storage unit. Talk with your insurance agent about switching to a less expensive temporary coverage plan, as vehicle insurance laws vary from state to state. Common coverage plans for cars in storage are comp-only and seasonal. If you park an uninsured vehicle in a storage unit, you run the risk of receiving a citation or having your license suspended. Don’t forget to switch your insurance when your car is back on the road!"
			}
		]
	}
];

export { CAR_STORAGE_DATA };
